// Translation for de
export const de = {
        common: {
            save: 'Speichern',
            cancel: 'Abbrechen',
            close: 'Schließen',
            delete: 'Löschen',
            edit: 'Bearbeiten',
            activate: 'Aktivieren',
            add: 'Hinzufügen',
            saving: 'Speichere...',
            loading: 'Lade...',
            active: 'AKTIV',
            inUse: 'In Verwendung',
            test: 'Testen',
            searchApps: 'Apps suchen...',
            betaBanner: 'BETA - Service ist noch nicht verfügbar!'
        },
        header: {
            creditBalance: 'Guthaben',
            minutes: 'MIN'
        },
        auth: {
            signIn: 'Anmelden',
            signUp: 'Registrieren',
            username: 'Benutzername',
            password: 'Passwort',
            continue: 'Weiter',
            noAccount: 'Noch kein Konto?',
            hasAccount: 'Bereits ein Konto?',
            loginError: 'Anmeldung fehlgeschlagen',
            invalidCredentials: 'Ungültiger Benutzername oder Passwort',
            rateLimited: 'Zu viele Anmeldeversuche. Bitte warte einen Moment.',
            sessionExpired: 'Deine Sitzung ist abgelaufen. Bitte verwende einen neuen Magic Link.',
            magicLinkInvalid: 'Der Login-Link ist ungültig oder abgelaufen.',
            magicLinkSuccess: 'Willkommen! Du wurdest erfolgreich angemeldet.',
            magicLinkProcessing: 'Anmeldung wird verarbeitet...',
            connectionError: 'Verbindungsfehler. Bitte versuche es erneut.'
        },
        profile: {
            myProgress: 'Mein Lernfortschritt',
            signOut: 'Abmelden',
            plan: 'Plan: '
        },
        settings: {
            title: 'Einstellungen',
            tabs: {
                uiSettings: 'UI-Einstellungen',
                systemPrompt: 'System-Prompt',
                llmProfiles: 'LLM Profile',
                ttsProfiles: 'TTS Profile',
                language: 'Sprache',
            },
            uiSettings: {
                title: 'Benutzeroberfläche',
                themeMode: 'Theme-Modus',
                darkMode: 'Dark Mode',
                lightMode: 'Light Mode',
                themeColor: 'Systemfarbe',
                themeColorDesc: 'Wähle die Akzentfarbe für Buttons, Icons und Highlights',
                background: 'Hintergrund',
                backgroundDesc: 'Wähle einen Hintergrund für deine Arbeitsumgebung',
                selectBackgroundColor: 'Hintergrundfarbe wählen',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'Fokus',
                    concentration: 'Konzentration',
                    relaxation: 'Entspannung',
                    lianas: 'Lianen',
                    color: 'Farbe'
                },
                backgroundColors: {
                    deepDark: 'Tiefdunkel',
                    darkGrey: 'Dunkelgrau',
                    midnightBlue: 'Mitternachtsblau',
                    indigo: 'Indigo',
                    darkTeal: 'Dunkles Türkis',
                    brown: 'Braun',
                    darkRed: 'Dunkelrot',
                    deepPurple: 'Tiefes Purpur',
                    pureWhite: 'Reinweiß',
                    softWhite: 'Sanftes Weiß',
                    lightGrey: 'Hellgrau',
                    paleBlue: 'Blassblau',
                    paleGreen: 'Blassgrün',
                    paleOrange: 'Blassorange',
                    lavender: 'Lavendel',
                    blueGrey: 'Blaugrau'
                }
            },
            systemPrompt: {
                label: 'System-Prompt:',
                placeholder: 'Lade System-Prompt...',
                emptyError: 'System-Prompt darf nicht leer sein!',
                saveSuccess: '✓ System-Prompt erfolgreich gespeichert!',
                loadError: 'Fehler beim Laden des System-Prompts',
                saveError: 'Fehler beim Speichern'
            },
            llmProfiles: {
                addButton: '+ Neue Verbindung hinzufügen',
                newConnection: 'Neue Verbindung',
                editConnection: 'Verbindung bearbeiten',
                emptyState: 'Keine LLM-Verbindungen vorhanden. Klicke unten um eine hinzuzufügen.',
                loadingProfiles: 'Lade Profile...',
                nameLabel: 'Name *',
                namePlaceholder: 'z.B. OpenAI GPT-4',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'API Key *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'Modell *',
                modelPlaceholder: 'gpt-4, mistral-tiny, etc.',
                allFieldsRequired: 'Alle Felder müssen ausgefüllt sein!',
                saveSuccess: '✓ Profil erfolgreich gespeichert!',
                deleteConfirm: 'Möchtest du "{name}" wirklich löschen?',
                profileNotFound: 'Profil nicht gefunden!',
                loadError: 'Fehler beim Laden der Profile',
                saveError: 'Fehler beim Speichern',
                activateError: 'Fehler beim Aktivieren',
                deleteError: 'Fehler beim Löschen',
                modelInfo: 'Modell: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ Neue Stimme hinzufügen',
                newVoice: 'Neue Stimme',
                editVoice: 'Stimme bearbeiten',
                emptyState: 'Keine TTS-Profile vorhanden. Klicke unten um eine hinzuzufügen.',
                loadingProfiles: 'Lade TTS-Profile...',
                nameLabel: 'Name',
                namePlaceholder: 'z.B. Mein ElevenLabs Adam',
                providerLabel: 'Anbieter',
                providerPlaceholder: 'z.B. ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (Lokal)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.beispiel.com/tts',
                apiKeyLabel: 'API Key *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'Modell ID *',
                modelIdPlaceholder: 'z.B. eleven_monolingual_v1',
                voiceIdLabel: 'Voice ID',
                voiceIdPlaceholder: 'z.B. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'Alle Felder müssen ausgefüllt sein!',
                saveSuccess: '✓ TTS-Profil erfolgreich gespeichert!',
                deleteConfirm: 'Möchtest du "{name}" wirklich löschen?',
                loadError: 'Fehler beim Laden der TTS-Profile',
                saveError: 'Fehler beim Speichern',
                activateError: 'Fehler beim Aktivieren',
                deleteError: 'Fehler beim Löschen'
            },
            language: {
                title: 'Sprache wählen',
                description: 'Wähle deine bevorzugte Sprache für die Benutzeroberfläche'
            },
        },
        chat: {
            ready: 'Bereit',
            start: 'START',
            stop: 'STOP',
            initialMessage: 'Klicke START für Realtime-Gespräch.',
            listening: 'Höre zu...',
            speaking: 'Thorsten spricht...',
            userLabel: 'Du',
            aiLabel: 'KI',
            modalTitle: 'Thorsten AI Chat',
            inputPlaceholder: 'Nachricht eingeben...',
            send: 'Senden',
            loginRequired: 'Bitte melden Sie sich an, um diesen Service nutzen zu können.',
            loginButton: 'Jetzt anmelden',
            magicLinkRequired: 'Bitte verwende einen Magic Link, um dich anzumelden.',
            creditLimitError: 'Ihr Stundenkontingent ist aufgebraucht. Bitte upgraden Sie Ihren Plan (Medium/Premium), um fortzufahren.',
            serviceDisabled: 'Der Chat-Dienst ist derzeit nicht verfügbar. Bitte versuchen Sie es später erneut.',
            parentNotice: 'Hinweis: Deine Eltern können diese Unterhaltung jederzeit lesen.'
        },
        chatHistory: {
            title: 'Chat-Verlauf',
            noSessions: 'Noch keine Unterhaltungen vorhanden.',
            loadMore: 'Mehr laden',
            back: 'Zurück',
            messages: 'Nachrichten',
            untitledSession: 'Unterhaltung',
            loadError: 'Chat-Verlauf konnte nicht geladen werden',
            accessDenied: 'Zugriff verweigert'
        },
        notifications: {
            error: 'Fehler',
            success: 'Erfolg',
            info: 'Information',
            unknownError: 'Ein unbekannter Fehler ist aufgetreten'
        },
        cookie: {
            message: 'Diese Website verwendet Cookies, um Ihnen die bestmögliche Nutzererfahrung zu bieten.',
            accept: 'Einverstanden'
        },
        curriculum: {
            buttonLabel: 'Lehrplan',
            buttonTitle: 'Lehrplan-Inhalte anzeigen',
            modalTitle: '{app} Lehrplan',
            sections: {
                topic: 'Lehrplan-Thema',
                explanation: 'Kindgerechte Erklärung',
                chat: 'Fragen an die KI',
                studentProfile: 'Schülerprofil'
            },
            chat: {
                hint: 'Stelle eine Frage zum Lehrplan-Thema. Die KI hilft dir zu verstehen, warum dieses Thema wichtig ist.',
                parentNotice: 'Hinweis: Deine Eltern können diese Unterhaltung jederzeit lesen.',
                placeholder: 'Frage eingeben …',
                inputAria: 'Frage an die KI',
                send: 'Senden',
                sending: 'Sendet …',
                empty: 'Die KI hat keine Antwort geliefert. Bitte versuche es erneut.',
                noTopic: 'Für dieses Thema steht kein Lehrplan-Inhalt für Fragen bereit.',
                requestFailed: 'Antwort konnte nicht erzeugt werden.'
            },
            topic: {
                empty: 'Für diese Micro-App ist im Lehrplan-Backend kein Thema hinterlegt.',
                missingDetail: 'Detaillierte Lehrplan-Daten zu dieser Micro-App stehen im Backend noch nicht zur Verfügung.',
                learningGoals: 'Lernziele',
                prerequisites: 'Voraussetzungen',
                unitLabel: 'Einheit',
                durationLabel: 'Dauer',
                difficultyLabel: 'Schwierigkeit',
                hours: 'Std.',
                minutes: 'Min.'
            },
            explanation: {
                empty: 'Keine kindgerechte Erklärung verfügbar.',
                loadingPrepare: 'KI bereitet Erklärung vor',
                loadingExplain: 'KI erklärt das Thema kindgerecht',
                requestFailed: 'Kindgerechte Erklärung konnte nicht erzeugt werden.'
            },
            studentProfile: {
                country: 'Land',
                region: 'Bundesland',
                schoolType: 'Schulform',
                grade: 'Klasse',
                noContext: 'Kein Schülerkontext verfügbar.',
                childProfileNotFound: 'Zum aktuellen Login-Token wurde kein Schülerprofil im Backend gefunden.',
                loginProfileIncomplete: 'Das Login-Profil enthält noch keinen vollständigen Schülerkontext.',
                educationContextNotFound: 'Es wurde ein Schülerprofil gefunden, aber keine Bildungszuordnung.',
                noToken: 'Kein eingeloggter Schüler gefunden.'
            },
            errors: {
                signInRequired: 'Bitte einloggen, um den Lehrplan zu sehen.',
                appIdMissing: 'App-ID fehlt.',
                loadFailed: 'Lehrplan-Daten konnten nicht geladen werden.'
            }
        }
    };
